import React from "react";
import "./styles.css"; // Usa los estilos existentes

const TrainingInfoModal = ({
  show,
  title,
  description,
  primaryAction,
  secondaryAction,
  onClose,
}) => {
  if (!show) return null;

  return (
    <div className="training-form-modal-overlay">
      <div className="training-info-modal-content p-5 gap-3 d-flex flex-column">
        <span className="training-info-modal-title">{title}</span>

        {description && (
          <p className="training-info-modal-description m-0">{description}</p>
        )}

        <div className="d-flex justify-content-center gap-2 flex-wrap">
          {primaryAction && (
            <button
              className="training-info-modal-button-primary btn btn-primary px-4"
              onClick={primaryAction.onClick}
            >
              {primaryAction.label}
            </button>
          )}
          {secondaryAction && (
            <button
              className="training-info-modal-button-secondary btn btn-outline-primary px-4"
              onClick={secondaryAction.onClick}
            >
              {secondaryAction.label}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrainingInfoModal;
